var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParking = function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13 6.5a4.5 4.5 0 1 1 4.5 4.5A4.49 4.49 0 0 1 13 6.5M6.5 22A4.5 4.5 0 1 0 2 17.5 4.49 4.49 0 0 0 6.5 22m11 0a4.5 4.5 0 1 0-4.5-4.5 4.49 4.49 0 0 0 4.5 4.5",
    opacity: 0.3
  })));
};
export default SvgParking;